import { Breadcrumb, Button, Card, Col, Divider, Empty, Input, message, Modal, Row, Select, Table } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation, MutationFn, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import { client } from '../../services/api';
import {
  ActivityJoinedAction,
  ActivityJoinedRecord,
  MarketingActivityRuleKey,
  ReservationDiscountSchema,
} from '../../types/marketingActivity';
import { GUser } from '../user/Users';
import { MarketingActivityData } from './ReserveActivities';

const DEFAULT_ROBOT_USER_ID = 0; // robot userId 为0；
const DEFAULT_C39X_REASON = '预约课程:C39X:Robot';
const DEFAULT_INSERT_RANGE = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

interface ContainedSerialActivityJoinedRecord extends ActivityJoinedRecord {
  serialNumber: number;
  key: string;
}

export interface EnrollmentGroupsData {
  enrollmentGroups: {
    name: string;
    id: number;
  }[];
}

const usersQuery = gql`
  query GetUser($mobile: String, $ids: [ID]) {
    users(mobile: $mobile, ids: $ids) {
      id
      name
      mobile
      gender
      region
      avatarUrl
    }
  }
`;

export const getActivitiesList = gql`
  query getActivitiesQuery($types: [ID], $activityIds: [ID]) {
    activities(types: $types, activityIds: $activityIds) {
      id
      name
      rules {
        id
        ruleKey
        ruleType
        ruleValue
      }
    }
  }
`;

const getEnrollmentGroupsQuery = gql`
  query getEnrollmentGroups($ids: [ID], $teacherIds: [ID], $skuIds: [ID], $name: String) {
    enrollmentGroups(ids: $ids, teacherIds: $teacherIds, skuIds: $skuIds, name: $name) {
      id
      name
    }
  }
`;

export const getJoinedMarketingActivitiyRecords = gql`
  query joinedMarketingActivitiyRecords($activityId: Int, $sourceId: [ID]) {
    joinedMarketingActivitiyRecords(activityId: $activityId, sourceId: $sourceId) {
      id
      createdAt
      reason
      userId
    }
  }
`;

const batchCreateActivityJoinedRecordMutation = gql`
  mutation batchCreateActivityJoinedRecord($activityId: Int, $joinedRecords: [JSON]) {
    batchCreateActivityJoinedRecord(activityId: $activityId, joinedRecords: $joinedRecords) {
      id
    }
  }
`;

interface EnrollmentGroupJoinedMarketingActivitiyData {
  joinedMarketingActivitiyRecords: ContainedSerialActivityJoinedRecord[];
}

interface State {
  mobile: string;
  isUserInfoModalVisible: boolean;
  selectedEnrollmentGroups: string[];
  selectedInsertValue: number;
  isConfirmModalVisible: boolean;
  selectedEnrollmentGroupId: number;
  isUserInfoModalOnTableVisible: boolean;
  userId: number;
  enrollmentGroups: {
    id: number;
    name: string;
  }[];
}

export class ReserveAddRobots extends Component<RouteComponentProps<{ id: string }>, State> {
  private realPersonUserId: number; // 用户确认信息时获取，不涉及state

  constructor(props: RouteComponentProps<{ id: string }>) {
    super(props);

    this.state = {
      mobile: '',
      isUserInfoModalVisible: false,
      isConfirmModalVisible: false,
      selectedEnrollmentGroups: [],
      selectedEnrollmentGroupId: 0,
      selectedInsertValue: 0,
      isUserInfoModalOnTableVisible: false,
      userId: 0, // 点击表格中按钮时获取
      enrollmentGroups: [],
    };

    this.onMobileInput = this.onMobileInput.bind(this);
    this.onDetaiInfoClick = this.onDetaiInfoClick.bind(this);
  }

  onMobileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      mobile: e.target.value,
    });
  };

  onDetaiInfoClick() {
    if (this.state.mobile) {
      this.setState({
        isUserInfoModalVisible: true,
      });
    } else {
      message.info('请输入手机号');
    }
  }

  getUserDetailInfo() {
    if (!this.state.isUserInfoModalVisible) {
      return null;
    }
    return (
      <Query query={usersQuery} variables={{ mobile: this.state.mobile }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = data.users;

          if (!user) {
            return <div>未找到用户</div>;
          }

          return this.getUserDetailInfoResult(user);
        }}
      </Query>
    );
  }

  getUserDetailInfoByTableUserId(userId: number) {
    if (!this.state.isUserInfoModalOnTableVisible) {
      return null;
    }
    return (
      <Query query={usersQuery} variables={{ ids: [userId] }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = data.users;

          if (!user) {
            return message.info('该用户为Robot！');
          }

          return this.getUserDetailInfoResultByTableUserId(user);
        }}
      </Query>
    );
  }

  async componentDidMount() {
    const responseActivitiesList = await client.query<MarketingActivityData>({
      query: getActivitiesList,
      variables: { activityIds: [this.props.match.params.id] },
    });

    const { activities } = responseActivitiesList.data;
    const [activitiy] = activities;
    const enrollmentGroupIds: number[] = [];

    for (const rule of activitiy.rules) {
      if (rule.ruleKey === MarketingActivityRuleKey.DETAIL_RESERVATION_DISCOUNT) {
        const ruleValue = rule.ruleValue && (rule.ruleValue as ReservationDiscountSchema);
        enrollmentGroupIds.push(ruleValue.groupId);
      }
    }

    const responseEnrollmentGroups = await client.query<EnrollmentGroupsData>({
      query: getEnrollmentGroupsQuery,
      variables: { ids: enrollmentGroupIds },
    });

    const { enrollmentGroups } = responseEnrollmentGroups.data;

    this.setState({ enrollmentGroups });
  }

  async onConfirmModalHandleOk(
    batchCreateActivityJoinedRecordMutation: MutationFn<
      any,
      {
        activityId: number;
        joinedRecords: {
          reason: string;
          userId: number;
          sourceTime: Date;
          source: ActivityJoinedAction;
          sourceId: number;
        }[];
      }
    >,
  ) {
    this.setState({
      isConfirmModalVisible: false,
    });
    const { selectedEnrollmentGroups, mobile } = this.state;

    if (selectedEnrollmentGroups.length === 0) {
      message.error('请选择社群');
      return;
    }

    if (!mobile) {
      message.error('请输入手机号');
      return;
    }

    if (!this.realPersonUserId) {
      message.error('请确认用户信息！');
      return;
    }

    try {
      await batchCreateActivityJoinedRecordMutation();
      message.success('添加成功！');
    } catch {
      message.error('添加失败！');
    }
  }

  getUserDetailInfoResult(user: GUser) {
    this.realPersonUserId = user.id;
    return (
      <Modal
        width="60%"
        visible={this.state.isUserInfoModalVisible}
        onCancel={() => {
          this.setState({ isUserInfoModalVisible: false });
        }}
        onOk={() => {
          this.setState({ isUserInfoModalVisible: false });
        }}
      >
        <Card title="用户信息" type="inner">
          <Row gutter={24}>
            <Col span={6} style={{ textAlign: 'right' }}>
              ID:
            </Col>
            <Col span={6}>{user.id}</Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              微信昵称:
            </Col>
            <Col span={6}>{user.name}</Col>
          </Row>
          <Row gutter={24}>
            <Col span={6} style={{ textAlign: 'right' }}>
              手机号:
            </Col>
            <Col span={6}>{user.mobile}</Col>
          </Row>
          <Row gutter={24}>
            <Col span={6} style={{ textAlign: 'right' }}>
              微信头像:
            </Col>
            <Col span={6}>
              <img src={user.avatarUrl} />
            </Col>
          </Row>
        </Card>
      </Modal>
    );
  }

  getUserDetailInfoResultByTableUserId(user: GUser) {
    if (!this.state.isUserInfoModalOnTableVisible) {
      return null;
    }
    return (
      <Modal
        width="60%"
        visible={this.state.isUserInfoModalOnTableVisible}
        onCancel={() => {
          this.setState({ isUserInfoModalOnTableVisible: false });
        }}
        onOk={() => {
          this.setState({ isUserInfoModalOnTableVisible: false });
        }}
      >
        <Card title="用户信息" type="inner">
          <Row gutter={24}>
            <Col span={6} style={{ textAlign: 'right' }}>
              ID:
            </Col>
            <Col span={6}>{user.id}</Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              微信昵称:
            </Col>
            <Col span={6}>{user.name}</Col>
          </Row>
          <Row gutter={24}>
            <Col span={6} style={{ textAlign: 'right' }}>
              手机号:
            </Col>
            <Col span={6}>{user.mobile}</Col>
          </Row>
          <Row gutter={24}>
            <Col span={6} style={{ textAlign: 'right' }}>
              微信头像:
            </Col>
            <Col span={6}>
              <img src={user.avatarUrl} />
            </Col>
          </Row>
        </Card>
      </Modal>
    );
  }

  onUserInfoClick(userId: number) {
    this.setState({
      userId,
      isUserInfoModalOnTableVisible: true,
    });
  }

  getTables() {
    return (
      <Query<EnrollmentGroupJoinedMarketingActivitiyData>
        query={getJoinedMarketingActivitiyRecords}
        variables={{ activityId: this.props.match.params.id, sourceId: [this.state.selectedEnrollmentGroupId] }}
      >
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const joinedMarketingActivitiyRecords = (data && data.joinedMarketingActivitiyRecords) || [];
          const dataSource: ContainedSerialActivityJoinedRecord[] = joinedMarketingActivitiyRecords.map(
            (item, index) => {
              item.key = item.id;
              item.createdAt = moment(item.createdAt).format('L');
              item.serialNumber = index + 1;
              return item;
            },
          );

          return (
            <Table
              size="small"
              columns={[
                {
                  title: '预约序号',
                  key: 'serialNumber',
                  dataIndex: 'serialNumber',
                },
                {
                  title: '用户ID',
                  key: 'userId',
                  dataIndex: 'userId',
                },
                {
                  title: '预约时间',
                  key: 'createdAt',
                  dataIndex: 'createdAt',
                },
                {
                  title: '详细信息',
                  key: 'operation',
                  dataIndex: 'userId',
                  width: '10%',
                  render: record => {
                    return (
                      <>
                        <Button
                          type="primary"
                          onClick={() => {
                            this.onUserInfoClick(record.userId);
                          }}
                        >
                          详细信息
                        </Button>
                      </>
                    );
                  },
                },
              ]}
              dataSource={dataSource}
              style={{ marginTop: '10px', width: '60%' }}
            />
          );
        }}
      </Query>
    );
  }

  render() {
    const selectedEnrollmentGroups = this.state.selectedEnrollmentGroups;
    const insertValue = this.state.selectedInsertValue;
    const activityId = Number(this.props.match.params.id);
    const reason = DEFAULT_C39X_REASON;

    const joinedRecords: {
      reason: string;
      sourceTime: Date;
      userId: number;
      source: ActivityJoinedAction;
      sourceId: number;
    }[] = [];

    for (const enrollmentGroup of selectedEnrollmentGroups) {
      let i = insertValue;
      while (i > 0) {
        const param = {
          reason,
          sourceTime: new Date(),
          userId: DEFAULT_ROBOT_USER_ID,
          source: ActivityJoinedAction.ENROLLMENT_GROUP,
          sourceId: Number(enrollmentGroup),
        };
        joinedRecords.push(param);
        i -= 1;
      }

      const realPerson = {
        reason,
        userId: this.realPersonUserId,
        sourceTime: new Date(),
        source: ActivityJoinedAction.ENROLLMENT_GROUP,
        sourceId: Number(enrollmentGroup),
      };

      joinedRecords.push(realPerson);
    }

    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/marketing`}>营销活动</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>水军配置</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Row gutter={24}>
            <Col span={2} style={{ marginTop: '6px' }}>
              手机号码:
            </Col>
            <Col span={4}>
              <Input placeholder="请输入完整手机号" onChange={this.onMobileInput} />
            </Col>
            <Col span={3} style={{ textAlign: 'right' }}>
              <Button type="primary" onClick={this.onDetaiInfoClick}>
                详细信息
              </Button>
            </Col>
            {this.getUserDetailInfo()}
          </Row>

          <Row gutter={24} style={{ marginTop: '10px' }}>
            <Col span={2} style={{ marginTop: '6px' }}>
              选择社群:
            </Col>
            <Col span={9}>
              <Select
                mode="multiple"
                style={{ width: '100%' }}
                placeholder="选择社群"
                onChange={(value: string[]) => {
                  this.setState({
                    selectedEnrollmentGroups: value,
                  });
                }}
              >
                {this.state.enrollmentGroups.map(enrollmentGroup => {
                  return <Select.Option key={String(enrollmentGroup.id)}>{enrollmentGroup.name} </Select.Option>;
                })}
              </Select>
            </Col>
          </Row>

          <Row gutter={24} style={{ marginTop: '10px' }}>
            <Col span={2} style={{ marginTop: '6px' }}>
              插入序号:
            </Col>
            <Col span={9}>
              <Select
                placeholder="请插入序号"
                style={{ width: 120 }}
                onChange={(value: number) => {
                  this.setState({
                    selectedInsertValue: value,
                  });
                }}
              >
                {DEFAULT_INSERT_RANGE.map(item => {
                  return <Select.Option key={String(item)}>{item}</Select.Option>;
                })}
              </Select>
            </Col>
          </Row>

          <Row gutter={24} style={{ marginTop: '10px' }}>
            <Col span={3} style={{ marginTop: '6px' }}>
              <Button
                type="primary"
                onClick={() => {
                  this.setState({
                    isConfirmModalVisible: true,
                  });
                }}
              >
                确认添加
              </Button>
            </Col>
          </Row>

          <Mutation
            mutation={batchCreateActivityJoinedRecordMutation}
            variables={{
              activityId,
              joinedRecords,
            }}
            refetchQueries={[
              {
                query: getJoinedMarketingActivitiyRecords,
                variables: {
                  activityId: this.props.match.params.id,
                  sourceId: [this.state.selectedEnrollmentGroupId],
                },
              },
            ]}
          >
            {batchCreateActivityJoinedRecordMutation => {
              return (
                <Modal
                  title="Basic Modal"
                  visible={this.state.isConfirmModalVisible}
                  onCancel={() => {
                    this.setState({
                      isConfirmModalVisible: false,
                    });
                  }}
                  onOk={async () => {
                    await this.onConfirmModalHandleOk(batchCreateActivityJoinedRecordMutation);
                  }}
                >
                  确认添加吗？
                </Modal>
              );
            }}
          </Mutation>

          <Divider />

          <Row gutter={24} style={{ marginTop: '10px' }}>
            <Col span={2} style={{ marginTop: '6px' }}>
              选择社群:
            </Col>
            <Col span={4}>
              <Select
                style={{ width: '100%' }}
                placeholder="选择社群"
                onChange={(value: number) => {
                  this.setState({
                    selectedEnrollmentGroupId: value,
                  });
                }}
              >
                {this.state.enrollmentGroups.map(enrollmentGroup => {
                  return <Select.Option key={String(enrollmentGroup.id)}>{enrollmentGroup.name} </Select.Option>;
                })}
              </Select>
            </Col>
          </Row>

          {this.getTables()}
          {this.getUserDetailInfoByTableUserId(this.state.userId)}
        </Card>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/marketing/ReserveAddRobots.tsx